import { AnyAction } from 'redux'
import { IInvoice } from '../../models/Invoice'
import { AuthorizationActions } from '../userAccount/actionNames'
import { InvoiceActions } from './actionNames'

export default function(
  store: Readonly<IInvoiceStore> = {},
  action: AnyAction,
) {
  switch (action.type) {
    case InvoiceActions.Accepted:
      return {
        ...store,
        ...action.invoice,
        newInvoice: action.newInvoice,
        reservationId: action.id,
      }
    case InvoiceActions.Rejected:
      return { reservationId: action.all ? undefined : store.reservationId }
    case InvoiceActions.ToggleLoading:
      return { ...store, loading: action.toggle }
    case AuthorizationActions.FlushState:
      return {}
  }

  return store
}

export interface IInvoiceStore extends IInvoice {
  reservationId?: string
  loading?: boolean
}
